import { defineStore } from 'pinia'
import { reactive, toRefs } from 'vue'

export const useSettingStore = defineStore('setting-store', () => {
  const state = reactive({
    emotionModalOpen: false,
    functionListOpen: false,
  })

  const handleEmotionOpen = () => {
    state.functionListOpen = false
    state.emotionModalOpen = true
  }

  const handleEmotionClose = () => {
    state.emotionModalOpen = false
  }

  const handleSwitchEmotion = () => {
    state.functionListOpen = false
    state.emotionModalOpen = !state.emotionModalOpen
  }

  const handleFuncOpen = () => {
    state.emotionModalOpen = false
    state.functionListOpen = true
  }

  const handleFuncClose = () => {
    state.functionListOpen = false
  }

  const handleSwitchFunc = () => {
    state.emotionModalOpen = false
    state.functionListOpen = !state.functionListOpen
  }

  return {
    ...toRefs(state),
    handleEmotionOpen,
    handleEmotionClose,
    handleSwitchEmotion,
    handleFuncOpen,
    handleFuncClose,
    handleSwitchFunc,
  }
})
